import { useMemo } from 'react';

export const useUploadProps = (projectId: number) => useMemo(() => ({
  serviceName: 'program',
  parentFolder: `onboarding-template/project-id-${projectId}`,
  isTemp: false,
}), [projectId]);
